import Axios from 'axios';

const URL = (...params) => `/api/v2/system/siteSettings/${params.join('/')}`;

export async function fetchParams () {
	const { data } = await Axios.get(URL());
	return data;
}

export async function getAllByKey (key) {
	const { data } = await Axios.get(URL('byKey', key));
	return data;
}

export async function save (params) {
	const { data } = await Axios.post(URL(), params);
	return data;
}
